/**
 * Wonder Herbals V2 — Animation Configuration
 * Framer Motion spring presets, easing curves, and duration tokens.
 * Import and use in all animated components for consistency.
 */

// ── Spring Presets ─────────────────────────────────────────────────────────────
export const springs = {
  /** Entrance animations — elements appearing on scroll */
  gentle: { type: 'spring' as const, stiffness: 80, damping: 20, mass: 1 },

  /** UI interactions — buttons, cards, small elements */
  snappy: { type: 'spring' as const, stiffness: 400, damping: 30 },

  /** Drawers and panels — cart, mobile menu */
  panel: { type: 'spring' as const, stiffness: 300, damping: 30 },

  /** Navbar show/hide on scroll */
  nav: { type: 'spring' as const, stiffness: 400, damping: 40 },

  /** Counter animations, progress bars */
  linear: { type: 'tween' as const, duration: 0.25, ease: 'easeOut' as const },
};

// ── Easing Curves ──────────────────────────────────────────────────────────────
export const easings = {
  /** Smooth in-out — standard page transitions */
  standard:   [0.25, 0.46, 0.45, 0.94] as [number, number, number, number],

  /** Starts fast, slows — elements entering viewport */
  decelerate: [0.0,  0.0,  0.2,  1.0 ] as [number, number, number, number],

  /** Starts slow, ends fast — elements leaving */
  accelerate: [0.4,  0.0,  1.0,  1.0 ] as [number, number, number, number],

  /** Springy overshoot — badges, count badges, add-to-cart success */
  overshoot:  [0.34, 1.56, 0.64, 1.0 ] as [number, number, number, number],
};

// ── Duration Tokens (seconds) ──────────────────────────────────────────────────
export const durations = {
  instant:  0.1,
  fast:     0.2,
  normal:   0.35,
  slow:     0.5,
  verySlow: 0.8,
};

// ── Scroll Reveal Variants ─────────────────────────────────────────────────────
export const revealVariants = {
  up:    { hidden: { opacity: 0, y: 40 },  visible: { opacity: 1, y: 0 } },
  down:  { hidden: { opacity: 0, y: -40 }, visible: { opacity: 1, y: 0 } },
  left:  { hidden: { opacity: 0, x: -40 }, visible: { opacity: 1, x: 0 } },
  right: { hidden: { opacity: 0, x: 40 },  visible: { opacity: 1, x: 0 } },
  fade:  { hidden: { opacity: 0 },          visible: { opacity: 1 } },
  scale: { hidden: { opacity: 0, scale: 0.95 }, visible: { opacity: 1, scale: 1 } },
};

// ── Stagger Container ──────────────────────────────────────────────────────────
export const staggerContainer = (staggerChildren = 0.08, delayChildren = 0) => ({
  hidden:  { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren, delayChildren },
  },
});
